import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { StyledRow, StyledField, StyledDataField } from '../../styled/styles';
import { ChangeDataJiraProject } from '../CreateJiraProject';
import { UserModel } from '@softwareone/plugin-project-management-common';

interface TableJiraProjectProps {
  createJiraProjectForm: ChangeDataJiraProject;
  jiraTeamMembersValue: UserModel[];
}

export const TableJiraProject: React.FC<TableJiraProjectProps> = ({ createJiraProjectForm, jiraTeamMembersValue }) => {
  const createDataJiraProject = (field: string, dataField: string | string[] | boolean | undefined) => {
    if (typeof dataField === 'boolean') {
      return { field, dataField: [dataField.toString()] };
    }
    return { field, dataField };
  };

  // Helper function to convert accountId to publicName
  const getPublicName = (accountId: string): string => {
    const user = jiraTeamMembersValue.find(u => u.accountId === accountId);
    return user?.publicName || accountId;
  };

  // Helper function to convert array of accountIds to array of publicNames
  const getPublicNames = (accountIds: string[]): string[] => {
    return accountIds.map(id => getPublicName(id));
  };

  const jiraProjectKey = createJiraProjectForm.jiraProjectKey || '';
  const jiraProjectTemplate = createJiraProjectForm.jiraProjectTemplate || '';
  const jiraProjectLeadName = getPublicName(createJiraProjectForm.jiraProjectLeadAccountId);

  const rowsJiraProject = [
    createDataJiraProject('Jira Project Key', jiraProjectKey),
    createDataJiraProject('Jira Project Template', jiraProjectTemplate),
    createDataJiraProject('Jira Project Lead', jiraProjectLeadName),
    createDataJiraProject('Jira Project Administrators', getPublicNames(createJiraProjectForm.jiraAdministrators)),
    createDataJiraProject('Jira Project Contributors', getPublicNames(createJiraProjectForm.jiraContributors)),
    createDataJiraProject('Jira Project Customers', getPublicNames(createJiraProjectForm.jiraCustomers)),
    createDataJiraProject('Visible to all swo employees', createJiraProjectForm.jiraVisibilityForSwoEmployees),
  ];
  return (
    <Box>
      <Typography variant="h6">Jira Project</Typography>
      {rowsJiraProject.map(row => (
        <StyledRow key={row.field}>
          <StyledField>{row.field}</StyledField>
          <StyledDataField>{Array.isArray(row.dataField) ? row.dataField.join(', ') : row.dataField}</StyledDataField>
        </StyledRow>
      ))}
    </Box>
  );
};
